import { factory, am } from './utils';
import config from './../config';

import httpClient, { jsonObjectToFormData } from '@/utils/httpClient';

const IMPORT = am(`IMPORT`);
const ADD_ADMINISTRATOR = am(`ADD_ADMINISTRATOR`);
const REMOVE_ADMINISTRATOR = am(`REMOVE_ADMINISTRATOR`);
const ADD_ANNOTATOR = am(`ADD_ANNOTATOR`);
const REMOVE_ANNOTATOR = am(`REMOVE_ANNOTATOR`);
const ADD_INTEGRATION = am(`ADD_INTEGRATION`);
const REMOVE_INTEGRATION = am(`REMOVE_INTEGRATION`);
const CHANGE_VISIBILITY = am(`CHANGE_VISIBILITY`);

export default {
  namespaced: true,
  ...factory({
    state: {
      isImportPending: false,
      isAddAdministratorPending: false,
      isRemoveAdministratorPending: false,
      isAddAnnotatorPending: false,
      isRemoveAnnotatorPending: false,
      isAddIntegrationPending: false,
      isRemoveIntegrationPending: false,
      isChangeVisibilityPending: false,
      isChangeVisibilityFailed: false
    },
    mutations: {
      [IMPORT.STARTED](state) {
        state.isImportPending = true;
      },
      [IMPORT.COMPLETED](state) {
        state.isImportPending = false;
      },
      [IMPORT.FAILED](state) {
        state.isImportPending = false;
      },
      [ADD_ADMINISTRATOR.STARTED](state) {
        state.isAddMemberPending = true;
      },
      [ADD_ADMINISTRATOR.COMPLETED](state, { id, administrators, updatedAt, updatedBy }) {
        state.isAddMemberPending = false;

        if (state.item && state.item.id === id) {
          state.item.administrators = administrators;
          state.item.updatedAt = updatedAt;
          state.item.updatedBy = updatedBy;
        }
      },
      [ADD_ADMINISTRATOR.FAILED](state) {
        state.isAddMemberPending = false;
      },
      [REMOVE_ADMINISTRATOR.STARTED](state) {
        state.isRemoveMemberPending = true;
      },
      [REMOVE_ADMINISTRATOR.COMPLETED](state, { id, administrators, updatedAt, updatedBy }) {
        state.isRemoveMemberPending = false;

        if (state.item && state.item.id === id) {
          state.item.administrators = administrators;
          state.item.updatedAt = updatedAt;
          state.item.updatedBy = updatedBy;
        }
      },
      [REMOVE_ADMINISTRATOR.FAILED](state) {
        state.isRemoveMemberPending = false;
      },

      [ADD_ANNOTATOR.STARTED](state) {
        state.isAddAnnotatorPending = true;
      },
      [ADD_ANNOTATOR.COMPLETED](state, { id, annotators, updatedAt, updatedBy }) {
        state.isAddAnnotatorPending = false;

        if (state.item && state.item.id === id) {
          state.item.annotators = annotators;
          state.item.updatedAt = updatedAt;
          state.item.updatedBy = updatedBy;
        }
      },
      [ADD_ANNOTATOR.FAILED](state) {
        state.isAddAnnotatorPending = false;
      },
      [REMOVE_ANNOTATOR.STARTED](state) {
        state.isRemoveAnnotatorPending = true;
      },
      [REMOVE_ANNOTATOR.COMPLETED](state, { id, annotators, updatedAt, updatedBy }) {
        state.isRemoveAnnotatorPending = false;

        if (state.item && state.item.id === id) {
          state.item.annotators = annotators;
          state.item.updatedAt = updatedAt;
          state.item.updatedBy = updatedBy;
        }
      },
      [REMOVE_ANNOTATOR.FAILED](state) {
        state.isRemoveAnnotatorPending = false;
      },

      [ADD_INTEGRATION.STARTED](state) {
        state.isAddIntegrationPending = true;
      },
      [ADD_INTEGRATION.COMPLETED](state, { id, integrations, updatedAt, updatedBy }) {
        state.isAddIntegrationPending = false;

        if (state.item && state.item.id === id) {
          state.item.integrations = integrations;
          state.item.updatedAt = updatedAt;
          state.item.updatedBy = updatedBy;
        }
      },
      [ADD_INTEGRATION.FAILED](state) {
        state.isAddIntegrationPending = false;
      },
      [REMOVE_INTEGRATION.STARTED](state) {
        state.isRemoveIntegrationPending = true;
      },
      [REMOVE_INTEGRATION.COMPLETED](state, { id, integrations, updatedAt, updatedBy }) {
        state.isRemoveIntegrationPending = false;

        if (state.item && state.item.id === id) {
          state.item.integrations = integrations;
          state.item.updatedAt = updatedAt;
          state.item.updatedBy = updatedBy;
        }
      },
      [REMOVE_INTEGRATION.FAILED](state) {
        state.isRemoveIntegrationPending = false;
      },

      [CHANGE_VISIBILITY.STARTED](state) {
        state.isChangeVisibilityPending = true;
        state.isChangeVisibilityFailed = false;
      },
      [CHANGE_VISIBILITY.COMPLETED](state, { id, isPublic }) {
        state.isChangeVisibilityPending = false;
        if (state.item && state.item.id === id) {
          state.item.isPublic = isPublic;
        }
      },
      [CHANGE_VISIBILITY.FAILED](state) {
        state.isChangeVisibilityPending = false;
        state.isChangeVisibilityFailed = true;
      }
    },
    actions: {
      async addAdministrator({ commit }, { id, email }) {
        try {
          commit(ADD_ADMINISTRATOR.STARTED);
          const response = await httpClient.post(config.apihostname+`/projects/${id}/administrators`, { email });
          commit(ADD_ADMINISTRATOR.COMPLETED, response);
        } catch (e) {
          commit(ADD_ADMINISTRATOR.FAILED);
          throw e;
        }
      },
      async removeAdministrator({ commit }, { id, email }) {
        try {
          commit(REMOVE_ADMINISTRATOR.STARTED);
          const response = await httpClient.delete(config.apihostname+`/projects/${id}/administrators`, { email });

          commit(REMOVE_ADMINISTRATOR.COMPLETED, response);
        } catch (e) {
          commit(REMOVE_ADMINISTRATOR.FAILED);
          throw e;
        }
      },
      async addAnnotator({ commit }, { id, email }) {
        try {
          commit(ADD_ANNOTATOR.STARTED);
          const response = await httpClient.post(config.apihostname+`/projects/${id}/annotators`, { email });
          commit(ADD_ANNOTATOR.COMPLETED, response);
        } catch (e) {
          commit(ADD_ANNOTATOR.FAILED);
          throw e;
        }
      },
      async removeAnnotator({ commit }, { id, email }) {
        try {
          commit(REMOVE_ANNOTATOR.STARTED);
          const response = await httpClient.delete(config.apihostname+`/projects/${id}/annotators`, { email });

          commit(REMOVE_ANNOTATOR.COMPLETED, response);
        } catch (e) {
          commit(REMOVE_ANNOTATOR.FAILED);
          throw e;
        }
      },
      async addIntegration({ commit }, { id, source, token }) {
        try {
          commit(ADD_INTEGRATION.STARTED);
          const response = await httpClient.post(config.apihostname+`/projects/${id}/integrations`, { source, token });
          commit(ADD_INTEGRATION.COMPLETED, response);
        } catch (e) {
          commit(ADD_INTEGRATION.FAILED);
          throw e;
        }
      },
      async removeIntegration({ commit }, { id, integrationId }) {
        try {
          commit(REMOVE_INTEGRATION.STARTED);
          const response = await httpClient.delete(config.apihostname+`/projects/${id}/integrations/${integrationId}`);

          commit(REMOVE_INTEGRATION.COMPLETED, response);
        } catch (e) {
          commit(REMOVE_INTEGRATION.FAILED);
          throw e;
        }
      },
      async import({ commit }, { id, file }) {
        try {
          commit(IMPORT.STARTED);
          const response = await httpClient.request(config.apihostname+`/projects/${id}/tasks/csv`, {
            json: false,
            method: 'POST',
            body: jsonObjectToFormData({ data: file })
          });

          commit(IMPORT.COMPLETED);

          return response;
        } catch (e) {
          commit(IMPORT.FAILED);
          throw e;
        }
      },
      async changeVisibility({ commit }, { id, isPublic }) {
        try {
          commit(CHANGE_VISIBILITY.STARTED);
          await httpClient.post(config.apihostname+`/projects/${id}/visibility`, { isPublic });
          commit(CHANGE_VISIBILITY.COMPLETED, { id, isPublic });
        } catch (e) {
          commit(CHANGE_VISIBILITY.FAILED);
          throw e;
        }
      }
    }
  })('topics', {
    async getById(id) {
      return httpClient.get(config.apihostname+`/projects/${id}`);
    },
    async getCollection() {
      const data = await httpClient.get(config.apihostname+'/projects/');

      return {
        data,
        total: data.length
      };
    },
    async create(data) {
      return httpClient.post(config.apihostname+'/projects/', data);
    },
    async update(id, data) {
      return httpClient.put(config.apihostname+`/projects/${id}`, data);
    },
    async delete(id) {
      return httpClient.delete(config.apihostname+`/projects/${id}`);
    }
  })
};
